(function () {
	'use strict';
	angular.module('app.setup')
		.controller('leandnaConnectKeyForm', leandnaConnectKeyForm);

	leandnaConnectKeyForm.$inject = ['$scope', 'leandnaConnectKeyConfigService'];
	function leandnaConnectKeyForm($scope, leandnaConnectKeyConfigService) {
		var vm = this;
		vm.siteId = $scope.siteId;
		vm.isSaveButtonDisabled = false;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		vm.reset = reset;
		vm.confirmSecret = confirmSecret;
		vm.confirmMode = false;
		vm.copySecret = copySecret;

		vm.leandnaConnectKey = {};
		vm.leandnaConnectKey.label = '';
		vm.secret = '';

		function save() {
			vm.isSaveButtonDisabled = true;
			leandnaConnectKeyConfigService.createLeandnaConnectKey(vm.siteId, vm.leandnaConnectKey).then(function (response) {
				if (_.isString(response)) {
					$scope.result(response, false);
				} else {
					// show the secret in a modal
					vm.confirmMode = true;
					vm.secret = response.data.secret;
				}
				vm.isSaveButtonDisabled = false;
			});
		}

		function confirmSecret() {
			$scope.result('LeanDNA Connect Key created successfully', true);
		}

		function reset() {
			vm.leandnaConnectKey.label = '';
			vm.secret = '';
		}

		function close() {
			$scope.result('', false);
		}

		function copySecret() {
			navigator.clipboard.writeText(vm.secret);
		}
	}
})();
